import { Image, Table, TableColumnsType } from "antd";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import useDriverWalletDetail from "hooks/driverWallets/useDriverWalletDetail";
import { IDriverWalletHistory } from "models/driverWallet";
import moment from "moment";
import AlterBy from "./components/AlterBy";
import WalletStatus from "./components/WalletStatus";
import { FinancePrivilege } from "models/account";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import ViewIcon from "components/Icons/ViewIcon";

export default function DriverWalletDetail() {
  const {
    role,
    data: { data, loading, page, per_page, total },
    handlePageChange,
  } = useDriverWalletDetail();

  return (
    <div className="w-full">
      <div className="w-full mt-8 px-4">
        {data?.driver && (
          <div className="w-full flex gap-x-3 items-center flex-wrap">
            <Image
              src={data?.driver.image}
              preview={false}
              height={100}
              width={100}
              className="rounded-full w-24 h-24"
            />
            <div className="flex flex-col gap-1">
              <p className="capitalize font-bold text-black text-lg">
                {data.driver.first_name} {data.driver.last_name}
              </p>
              <p className="text-gray-500 text-sm">{data.driver.phone}</p>
            </div>
            <div className="flex flex-col gap-1 ml-10">
              <p className="capitalize font-medium text-black text-base">
                {data.bank}
              </p>
              <p className="text-gray-500 text-sm">{data.account}</p>
            </div>
            <div className="flex flex-col gap-1 ml-10">
              <p className="capitalize font-medium text-black text-base">
                Balance
              </p>
              <p
                className={`${
                  data.balance > 0 ? "text-green-500" : "text-red-500"
                } text-sm font-bold`}
              >
                {data.balance.toFixed(2)}
              </p>
            </div>
          </div>
        )}
        <div className="w-full flex items-center justify-start mt-7">
          {FinancePrivilege.includes(role) && (
            <Link
              to={RouteName.DRIVER_DETAIL.replace(":id", data.driver_id)}
              className="rounded-ful hover:text-white flex items-center gap-2 px-10 bg-black text-white py-2 rounded-lg"
            >
              <ViewIcon /> Driver
            </Link>
          )}
        </div>
        <Table
          loading={loading}
          columns={columns}
          dataSource={data.histories}
          onChange={handlePageChange}
          pagination={{
            total,
            pageSize: per_page,
            current: page,
            nextIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <NextIcon />
              </span>
            ),
            prevIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <PreviousIcon />
              </span>
            ),
          }}
        />
      </div>
    </div>
  );
}

const columns: TableColumnsType<IDriverWalletHistory> = [
  {
    title: "Amount",
    dataIndex: "amount",
    render: (value: number) => <p>{value.toFixed(2)}</p>,
  },
  {
    title: "Status",
    dataIndex: "type",
    render: WalletStatus,
  },
  {
    title: "Alter By",
    render: AlterBy,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    render: (value: string) => (
      <p>{moment(value).format("MMM D, YYYY h:mm:ss:SSS A")}</p>
    ),
  },
];
